import {
  CREATE_RESPONSE_REQUEST,
  CREATE_RESPONSE_SUCCESS,
  CREATE_RESPONSE_FAILURE,
} from "../Types";

const initialState = {
  loading: false,
  success: false,
  data: null,
  error: null,
};

const CreateResponseReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_RESPONSE_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };

    case CREATE_RESPONSE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        data: action.payload,
        error: null,
      };

    case CREATE_RESPONSE_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default CreateResponseReducer;
